// Version : 0.0.1
// Author : SATHISH
// LastEdit : KARTHEESWARAN
// MODFIED DATE:26-08-2025
// LAST ADD: REMOVED UNWANTED CODES
import { docodeHexResponse } from '../../../_common/common.utils';
import AccountType from './account.types';

const INITIAL_STATE = {
	// ADD ACCOUNT DETAILS
	addAccountDetailsResponse: null,
	// UPDATE ACCOUNT DETAILS
	updateAccountDetailsResponse: null,
	// GET ACCOUNT LIST
	getAccountListResponse: null,
	getAccountListArr: [],
	// DELETE ACCOUNT DETAILS
	deleteAccountDetailsResponse: null,
};

const accountReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD ACCOUNT DETAILS START *********************** */
		case AccountType.ADD_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, addAccountDetailsResponse: action.payload };

		case AccountType.ADD_ACCOUNT_DETAILS_FAILURE:
			return { ...state, addAccountDetailsResponse: action.payload };

		case AccountType.ADD_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, addAccountDetailsResponse: null };
		/** ***************** ADD ACCOUNT DETAILS END *********************** */

		/** ***************** UPDATE ACCOUNT DETAILS START *********************** */
		case AccountType.UPDATE_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, updateAccountDetailsResponse: action.payload };

		case AccountType.UPDATE_ACCOUNT_DETAILS_FAILURE:
			return { ...state, updateAccountDetailsResponse: action.payload };

		case AccountType.UPDATE_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateAccountDetailsResponse: null };
		/** ***************** UPDATE ACCOUNT DETAILS END *********************** */

		/** ***************** GET ACCOUNT DETAILS START *********************** */
		case AccountType.GET_ACCOUNT_LIST_SUCCESS:
			return {
				...state,
				getAccountListResponse: action.payload,
				getAccountListArr: docodeHexResponse(action.payload, 'GetAllAccountListKey'),
			};

		case AccountType.GET_ACCOUNT_LIST_FAILURE:
			return { ...state, getAccountListResponse: action.payload };

		case AccountType.GET_ACCOUNT_LIST_RESPONSE_CHANGED:
			return { ...state, getAccountListResponse: null };
		/** ***************** GET ACCOUNT DETAILS END *********************** */

		/** ***************** DELETE ACCOUNT DETAILS START *********************** */
		case AccountType.DELETE_ACCOUNT_DETAILS_SUCCESS:
			return { ...state, deleteAccountDetailsResponse: action.payload };

		case AccountType.DELETE_ACCOUNT_DETAILS_FAILURE:
			return { ...state, deleteAccountDetailsResponse: action.payload };

		case AccountType.DELETE_ACCOUNT_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteAccountDetailsResponse: null };
		/** ***************** DELETE ACCOUNT DETAILS END *********************** */

		default:
			return state;
	}
};

export default accountReducer;
